import moment from 'moment';
import _ from 'lodash';

export const collaboratoreInitialValues = {
  allegatoContratto: '',
  reteProvenienza: '',
  ragioneSociale: '',
  partitaiva: '',
  indirizzoCompleto: '', // Indirizzo completo sede legale
  comune: '', // Comune sede legale
  provincia: '', // Provincia sede legale
  regione: '', // Regione sede legale
  cap: '', // CAP sede legale
  indirizzo: '', // Via e numero sede legale
  rea: '',
  registroImprese: '', // Comune + (prov) come stringa
  codiceAttivita: '',
  anagrafica: '', // Id anagrafica collegata
  profili: [],
  enasarcoNumeroIscrizione: '',
  enasarcoDataIscrizione: '',
  enasarcoDataCessazione: '',
  numeroCartaVersamento: '',
  tutor: 0,
  contratti: [],
  // agenzietecnocasa: [],
};

export const mapToCollaboratoreInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id || '',
    allegatoContratto: _.get(newValues, '_embedded.allegatoContratto.id') || null,
    reteProvenienza: newValues.reteProvenienza || '',
    ragioneSociale: newValues.ragioneSociale || '',
    partitaiva: newValues.partitaiva || '',
    indirizzoCompleto: newValues.indirizzoCompleto || '', // Indirizzo completo sede legale
    comune: newValues.comune || '', // Comune sede legale
    provincia: newValues.provincia || '', // Provincia sede legale
    regione: newValues.regione || '', // Regione sede legale
    cap: newValues.cap || '', // CAP sede legale
    numeroCivico: newValues.numeroCivico, // Numero civico sede legale
    nazione: newValues.nazione, // Nazione sede legale
    indirizzo: newValues.indirizzo || '', // Via e numero sede legale
    rea: newValues.rea || '',
    registroImprese: newValues.registroImprese || '', // Comune + (prov) come stringa
    codiceAttivita: newValues.codiceAttivita || '',
    anagrafica: newValues.anagrafica || '', // Id anagrafica collegata
    profili: newValues.profili
      ? _.orderBy(newValues.profili, 'dataInizioValidita', 'asc').map((profilo) => ({
        id: profilo.id,
        tipoProfiloCollaboratore: {
          value: profilo._embedded.tipoProfiloCollaboratore.id,
          label: profilo._embedded.tipoProfiloCollaboratore.nome,
        },
        collaboratore: profilo._embedded.collaboratore.id,
        gruppo: {
          value: _.get(profilo, '_embedded.gruppo.id', null),
          label: _.get(profilo, '_embedded.gruppo.nominativo', null) || _.get(profilo, '_embedded.gruppo.nome', null),
        },
        supervisore: profilo.supervisore,
        attivo: profilo.attivo,
        dataFineValidita: profilo.dataFineValidita ? moment.unix(profilo.dataFineValidita) : '',
        dataInizioValidita: profilo.dataInizioValidita ? moment.unix(profilo.dataInizioValidita) : '',
        agenziakiron: {
          value: _.get(profilo, '_embedded.agenziakiron.id', null),
          label: _.get(profilo, '_embedded.agenziakiron.nome', null),
        },
        createdAt: profilo.createdAt ? profilo.createdAt : '',
        responsabileArea: profilo.responsabileArea ? profilo.responsabileArea.nome : 'X',
      }))
      : [],
    contratti: newValues.contratti
      ? _.orderBy(newValues.contratti, 'dataDecorrenza', 'desc').map((contratto) => ({
        id: contratto.id,
        dataDecorrenza: contratto.dataDecorrenza ? moment.unix(contratto.dataDecorrenza) : '',
        dataRescissione: contratto.dataRescissione ? moment.unix(contratto.dataRescissione) : '',
        tipologia: contratto.tipologia,
        numero: contratto.numero,
        compensoMensile: contratto.compensoMensile,
        isNotNew: contratto.isNotNew,
        periodoRimborso: contratto.periodoRimborso,
        percentualeCaricoKiron: +contratto.percentualeCaricoKiron,
        attivo: contratto.attivo,
      }))
      : [],
    enasarcoNumeroIscrizione: newValues.enasarcoNumeroIscrizione || '',
    enasarcoDataIscrizione: newValues.enasarcoDataIscrizione ? moment.unix(newValues.enasarcoDataIscrizione) : '',
    enasarcoDataCessazione: newValues.enasarcoDataCessazione ? moment.unix(newValues.enasarcoDataCessazione) : '',
    numeroCartaVersamento: newValues.numeroCartaVersamento || '',
    tutor: newValues.tutor || 0,
    pignoramento: newValues.pignoramento || 0,
    notePignoramento: newValues.notePignoramento || '',
    campusAccessBlocked: newValues.campusAccessBlocked || 0,
    accessoSharedMail: newValues.accessoSharedMail || 0,
    // agenzietecnocasa: newValues.agenzietecnocasa || [], // Array di ID
  };

  return mappedValues;
};

export default collaboratoreInitialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/initialValues.js